import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HistoryIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M4.22026 6.76627L8.25727 7.05311C8.43202 7.06552 8.53715 6.8632 8.42654 6.72734L6.75659 4.6761L4.9362 2.59999C4.82028 2.46779 4.60246 2.53874 4.58663 2.71384L4.22026 6.76627Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.0198 7.69017C19.9947 5.54109 18.2365 3.82828 16.0613 2.85983C13.8861 1.89138 11.4367 1.73084 9.15376 2.40709C8.36574 2.64051 7.62124 2.96278 6.92374 3.34993L5.68809 1.94071C4.99262 1.14754 3.68568 1.57319 3.59069 2.6238L3.22432 6.67622C3.20014 6.94368 3.28455 7.20963 3.45855 7.41419C3.63255 7.61874 3.88151 7.74472 4.14938 7.76375L8.1864 8.05059C9.2349 8.12509 9.86568 6.91115 9.20204 6.09599L8.24077 4.91524C8.71667 4.67545 9.21089 4.47606 9.72179 4.32473C11.5482 3.78373 13.5077 3.91216 15.2478 4.68692C16.988 5.46168 18.3946 6.83193 19.2146 8.5512C20.0346 10.2705 20.2143 12.2259 19.7213 14.0658C19.2283 15.9058 18.095 17.5094 16.5252 18.5883C14.9554 19.6672 13.0521 20.1506 11.1577 19.9515C9.2633 19.7524 7.50212 18.8838 6.19092 17.5021C4.87973 16.1204 4.10457 14.3162 4.00488 12.414C3.97598 11.8624 3.50544 11.4388 2.95392 11.4677C2.40239 11.4966 1.97872 11.9671 2.00762 12.5186C2.13224 14.8964 3.10118 17.1517 4.74017 18.8788C6.37917 20.606 8.58064 21.6916 10.9486 21.9405C13.3166 22.1894 15.6957 21.5852 17.658 20.2365C19.6202 18.8879 21.0369 16.8834 21.6532 14.5835C22.2694 12.2836 22.0448 9.83926 21.0198 7.69017Z"
				fill="currentColor"
			/>
			<path
				d="M10.5 8.5C10.5 7.94772 10.9477 7.5 11.5 7.5C12.0523 7.5 12.5 7.94772 12.5 8.5V12.0859L13.7071 13.293C14.0976 13.6835 14.0976 14.3165 13.7071 14.707C13.3165 15.0976 12.6835 15.0976 12.293 14.707L10.5 12.9141V8.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HistoryIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HistoryIcon;
